import { render, staticRenderFns } from "./passwordSuccess.vue?vue&type=template&id=648eee1f&scoped=true"
import script from "./passwordSuccess.vue?vue&type=script&lang=js"
export * from "./passwordSuccess.vue?vue&type=script&lang=js"
import style0 from "./passwordSuccess.vue?vue&type=style&index=0&id=648eee1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648eee1f",
  null
  
)

export default component.exports